import { initializeApp, type FirebaseApp, type FirebaseOptions } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";

const config: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize only when we actually have a config. During SSR / build-time
// prerendering the env vars are absent and getAuth() would throw
// "auth/invalid-api-key". The marketing routes don't need auth, so we
// happily skip init in that case.
const canInit = !!config.apiKey;

export const firebaseApp: FirebaseApp | null = canInit ? initializeApp(config) : null;
export const firebaseAuth: Auth | null = firebaseApp ? getAuth(firebaseApp) : null;

export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL ||
  "https://europe-west3-tino247-2160e.cloudfunctions.net/api";
